import styled from 'styled-components';

export const Navbar = styled.div`
  flex-grow: 1;
`;
